const enableNativeStorageEvent = () => {
  console.log("[enableNativeStorageEvent]");
  if (typeof window === "undefined") {
    console.warn("native storage event can't be listened on node environment.");
    return;
  }
  window.KakaoPay.triggerStorageChangeEvent = (event) => {
    console.log("[storageEvent.ts] triggerStorageChangeEvent", event);
    const storageEvent = new CustomEvent("native_storage", {
      detail: {
        key: event.key,
        oldValue: event.old_value,
        newValue: event.new_value
      }
    });
    document.dispatchEvent(storageEvent);
  };
};
export {
  enableNativeStorageEvent
};
